import { create } from 'zustand';

// Store for the app-wide upgrade/upsell modal. It lives in its own module so
// FeatureGate can trigger the modal without importing UpgradeModal.jsx (which
// imports UpsellContent *from* FeatureGate — a cycle).
export const useUpgradeModal = create((set) => ({
    open: false,
    featureKey: null,
    show: (featureKey) => set({ open: true, featureKey }),
    hide: () => set({ open: false }),
}));

export const openUpgradeModal = (featureKey) => useUpgradeModal.getState().show(featureKey);
